import { useLocation, useParams } from "react-router-dom";

const useCurrentPath = () => {
  const location = useLocation();
  const params = useParams();
  let zz = location.pathname;
  for (const key in params) {
    zz = zz.replace("/" + params[key], "/:" + key);
    zz = zz.replace("&" + params[key], "&:" + key);
  }
  return {
    routePath: zz,
    pathname: location.pathname.endsWith("/")
      ? location.pathname
      : `${location.pathname}/`,
  };
};

export default useCurrentPath;
